import { SET_HEADER_HEIGHT, SET_HEADER_FACET } from 'reducers/actions-types';

export default Object.freeze({
    /**
     * Set header height
     * @param {number} height
     * @return {{type: *, height: *}}
     */
    setHeight({ height }) {
        return { type: SET_HEADER_HEIGHT, height };
    },
    /**
     * Set facet for header
     * @param {string} facet
     * @return {{type: *, facet: *}}
     */
    setFacet({ facet }) {
        return { type: SET_HEADER_FACET, facet };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/header/actions.js